/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DemoModeStatusResponse
 */
export interface DemoModeStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DemoModeStatusResponse
     */
    isDemo: boolean;
}

/**
 * Check if a given object implements the DemoModeStatusResponse interface.
 */
export function instanceOfDemoModeStatusResponse(value: object): value is DemoModeStatusResponse {
    if (!('isDemo' in value) || value['isDemo'] === undefined) return false;
    return true;
}

export function DemoModeStatusResponseFromJSON(json: any): DemoModeStatusResponse {
    return DemoModeStatusResponseFromJSONTyped(json, false);
}

export function DemoModeStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemoModeStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isDemo': json['is_demo'],
    };
}

  export function DemoModeStatusResponseToJSON(json: any): DemoModeStatusResponse {
      return DemoModeStatusResponseToJSONTyped(json, false);
  }

  export function DemoModeStatusResponseToJSONTyped(value?: DemoModeStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_demo': value['isDemo'],
    };
}

